import { Injectable } from '@angular/core';

import { select, Store } from '@ngrx/store';
import * as fastDeepEqual from 'fast-deep-equal';
import { distinctUntilChanged, filter, take } from 'rxjs/operators';

import * as SupportCenterActions from './support-center.actions';
import * as SupportCenterSelectors from './support-center.selectors';

@Injectable()
export class SupportCenterFacade {
  /**
   * Combine pieces of state using createSelector,
   * and expose them as observables through the facade.
   */
  supportCenterFolders$ = this.store.pipe(
    select(SupportCenterSelectors.getFolders),
    filter((folders) => folders != null),
    distinctUntilChanged(fastDeepEqual)
  );

  supportCenterFileList$ = (path: string) =>
    this.store.pipe(
      select(SupportCenterSelectors.getFilesList(path)),
      filter((fileList) => fileList != null),
      distinctUntilChanged(fastDeepEqual)
    );

  supportCenterFiles$ = (path: string) =>
    this.store.pipe(
      select(SupportCenterSelectors.getFiles(path)),
      filter((files) => files != null),
      distinctUntilChanged(fastDeepEqual)
    );

  constructor(private store: Store) {}

  /**
   * Use the initialization action to perform one
   * or more tasks in your Effects.
   */
  dispatchGetFolders() {
    this.store
      .pipe(select(SupportCenterSelectors.getFoldersLoaded), take(1))
      .subscribe((loaded) => {
        if (!loaded) {
          this.store.dispatch(SupportCenterActions.getFolders());
        }
      });
  }

  dispatchGetFiles(path: string) {
    this.store
      .pipe(select(SupportCenterSelectors.getFilesLoaded(path)), take(1))
      .subscribe((loaded) => {
        if (!loaded) {
          this.store.dispatch(SupportCenterActions.getFiles({ path }));
        }
      });
  }

  dispatchGetFilesList(path: string) {
    this.store
      .pipe(select(SupportCenterSelectors.getFilesListLoaded(path)), take(1))
      .subscribe((loaded) => {
        if (!loaded) {
          this.store.dispatch(SupportCenterActions.getFilesList({ path }));
        }
      });
  }
}
